import { usePhieuChiMutation } from './usePhieuChiMutation';
import { usePhieuChiTable } from './usePhieuChiTable';

export const usePhieuChiPage = () => {
  const tableState = usePhieuChiTable();
  const mutationState = usePhieuChiMutation({
    formMode: tableState.form.formMode,
    selectedObj: tableState.selection.selectedObj,
    shouldEditWithUpdatedData: tableState.editWithUpdatedDialog.open,
    editPhieuChiUuid: tableState.editWithUpdatedDialog.uuid,
    addItem: tableState.shared.addItem,
    updateItem: tableState.shared.updateItem,
    deleteItem: tableState.shared.deleteItem,
    handleCloseForm: tableState.form.handleCloseForm,
    clearSelection: tableState.selection.clearSelection,
    refreshData: tableState.shared.refreshData
  });

  return {
    searchDialog: tableState.searchDialog,
    formDialog: {
      open: tableState.form.showForm,
      formMode: tableState.form.formMode,
      isCopyMode: tableState.form.isCopyMode,
      detail: tableState.shared.detail,
      onClose: tableState.form.handleCloseForm,
      onSubmit: mutationState.handleSubmit,
      onAdd: tableState.form.handleAddClick,
      onEdit: tableState.form.handleEditClick,
      onDelete: tableState.form.handleDeleteClick,
      onCopy: tableState.form.handleCopyClick
    },
    multipleFormDialog: tableState.multipleFormDialog,
    editWithUpdatedDialog: {
      ...tableState.editWithUpdatedDialog,
      onClose: mutationState.handleCloseEditWithUpdatedData,
      onSubmit: mutationState.handleSubmit
    },
    deleteDialog: {
      open: tableState.form.showDelete,
      onClose: tableState.form.handleCloseDelete,
      selectedObj: tableState.selection.selectedObj,
      onDelete: tableState.shared.deleteItem,
      clearSelection: tableState.selection.clearSelection
    },
    bulkDeleteDialog: {
      open: tableState.form.showBulkDelete,
      onClose: tableState.form.handleCloseBulkDelete,
      onDelete: mutationState.handleDelete
    },
    table: tableState.table,
    detailTable: tableState.detailTable,
    actions: {
      isExporting: tableState.shared.isExporting,
      handleAddClick: tableState.form.handleAddClick,
      handleEditClick: tableState.form.handleEditClick,
      handleDeleteClick: tableState.form.handleDeleteClick,
      handleCopyClick: tableState.form.handleCopyClick,
      handleRowClick: tableState.form.handleRowClick,
      handleSearch: tableState.searchDialog.onOpen,
      handleRefresh: tableState.table.onRefresh
    },
    selection: tableState.selection
  };
};
